import { useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { useShoppingCardContext } from 'hb-react/shared/components/ShoppingCard/ShoppingCardContext';
import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';

const FixedWrapper = ({ children }) => {
  const frameTheme = useFrameTheme();

  return (
    <Wrapper bg={frameTheme.backgroundColor} justifyContent="space-between">
      {children}
    </Wrapper>
  );
};

const StaticWrapper = ({ children }) => (
  <Box pt={6} justifyContent="space-between">
    {children}
  </Box>
);

const ButtonToggleModal = () => {
  const { toggleModal } = useShoppingCardContext();

  return (
    <Button onClick={toggleModal} variant="inversed" mb={{ _: 3, m: 0 }}>
      {s__('NetworkEvents|Order Summary')}
    </Button>
  );
};

const Navigation = ({ children }) => {
  const breakpoint = useBreakpoint();

  const isFixed = useMemo(() => ['s', 'm'].includes(breakpoint), [breakpoint]);

  const Wrapper = isFixed ? FixedWrapper : StaticWrapper;

  return (
    <Wrapper>
      {children({
        isFixed,
        ButtonToggleModal,
        breakpoint,
      })}
    </Wrapper>
  );
};

export default Navigation;

const Wrapper = styled(Box)`
  padding: 16px 20px 16px 20px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
`;
